import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner, Accordion, audio, Col, Row, Container, Table, InputGroup } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postDataLogin, postData } from '../ApiServices/ApiService';
import AdminNavHeader from './AdminNavHeader';
import { FaDownload } from 'react-icons/fa';
import { FaCircleCheck } from "react-icons/fa6";
import { IoMail } from "react-icons/io5";
import { GoXCircleFill } from "react-icons/go";
import { IoIosCall } from "react-icons/io";
import { IoPersonCircle } from "react-icons/io5";
import ClipboardJS from 'clipboard';
import { BiLeftArrowAlt } from "react-icons/bi";


const CandidateDetailsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const testID = searchParams.get('id');

  const [candidateList, setCandidateList] = useState([]);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [pageLoader, setPageLoader] = useState(false);


  useEffect(() => {
    const jobDetailsList = async () => {
      setCandidateList([])
      setSuccess('');
      const payload = {
        "test_id": testID,
        //"test_id": "t_id_c_id_adm-8112817223101042045380104204538",
        "user_id": "1"
      }
      setPageLoader(true)
      try {
        await postData('admin_in/candidate-interview/get-interview-details', payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  console.log("respData.dataJ[0]", respData.dataJ[0]);
                  setCandidateList(respData.dataJ[0]);
                  // setAnalysisList(resp.dataJ[0].answer_analysis)
                  setPageLoader(false);
                  setLoading(false);
                  //setSuccess(resp.info);
                } else {
                  setLoading(false);
                  setPageLoader(false);
                  setSuccess(resp.info);
                }

              } else if (respData.statusCode === 500) {
                setLoading(false);
                setPageLoader(false);
                setSuccess(respData.info);
              } else {
                setLoading(false);
                setPageLoader(false);
                setSuccess('Job Details failed. Please check your credentials.');
              }
            }
            else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
              console.log('resp status else if : ', resp.status);
              setLoading(false);
              setPageLoader(false);
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                setLoading(false);
                setPageLoader(false);
                //   callRefreshTokenApi('getSfeBatch', '');
              }
              setSuccess('Looks Like Session Expired Please login..');
            } else {
              console.log('resp status else  : ', resp);
              setLoading(false);
              setPageLoader(false);
            }
          }).catch((error) => {
            setSuccess('Network Error');
            console.log('network error:', error);
            setLoading(false);
            setPageLoader(false);
          });
        }).catch((error) => {
          setLoading(false);
          setPageLoader('JobDetails failed. Please check your credentials or Network Error');
          console.log('network error:', error);

        });
      } catch (error) {
        setPageLoader(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Job Details failed', error);
      }
    }
    jobDetailsList();
  }, [])







 


  const [buttonText, setButtonText] = useState('Copy');

  const handleCopy = () => {
    const clipboard = new ClipboardJS('.copy-button', {
      text: function () {
        return candidateList?.exam_link;
      },
    });

    clipboard.on('success', () => {
      setButtonText('copied')
      clipboard.destroy();
    });

    clipboard.on('error', () => {
      alert('Failed to copy link to clipboard!');
      clipboard.destroy();
    });
  };


let formattedDate;
const originalDateString = candidateList?.create_at?.substring(0, 10);

if (originalDateString) {
    const date = new Date(originalDateString);    
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    formattedDate = date.toLocaleDateString(undefined, {
      timeZone: userTimeZone,
      day: '2-digit',
      month: 'short', // 'short' will give you the abbreviated month name like 'Jun'
      year: 'numeric'
    }).replace(/,/g, '')
    .replace(/\s/g, '-');
}





  const [showPopup, setShowPopup] = useState(false);





  return (
    <div className='dashboard-div ' style={{ overflowX: 'hidden' }}>
      
      {/* { verifyOtp != null && <LoginNavLoginPage></LoginNavLoginPage>} */}
       <AdminNavHeader ></AdminNavHeader>
      {success && <div className='error-msg'> {success}  </div>}
      {(!showPopup && <div style={{ overflowX: 'hidden', width: '100%' }} >
        <div className='candidate-title'> Candidate Information</div>

        {/* <h5 style={{ paddingLeft: '25px', paddingTop: '25px' }}>Personal Details :</h5> */}
        {pageLoader && (
          <div className="spinner-overlay" style={{ zIndex: 999 }}>
            <Spinner animation="border" role="status">
              <span className="sr-only"></span>
            </Spinner>
          </div>
        )}
        {/* {candidateList  &&( */}
        <div className='div-width'>
          <Row className='info-div'>
            <Col>
              <div >
                <div ><span className='info-title'>Name <IoPersonCircle className='marg-btm-4' /> :</span><span className='info-data' style={{ textTransform: 'capitalize' }}> {candidateList?.candidate_name}</span></div>
                <div ><span className='info-title'>Email <IoMail className='marg-btm-4' />:</span><span className='info-data'> {candidateList?.candidate_email}</span></div>
                {candidateList?.phone_number?.length > 0 &&(<div ><span className='info-title'>Phone Number   <IoIosCall className='marg-btm-4' />:</span><span className='info-data'> {candidateList?.country_code}{candidateList?.phone_number}</span></div>)}
                <div > <span className='info-title'>Job Id:</span> <span className='info-data'> {candidateList?.job_id}</span></div>
                {candidateList?.technologies_str && <div ><span className='info-title'>Skills:</span><span className='info-data'> {candidateList?.technologies_str}</span></div>}

                <div ><span className='info-title'>Exam Type:</span><span className='info-data'> {candidateList?.exam_type === 'THEORY' ? 'SKILLS': <span>{candidateList?.exam_type}</span>}</span></div>
                <div ><span className='info-title'>Questions Count:</span><span className='info-data'> {candidateList?.questions?.length}</span></div>
                {/* <div > <span className='info-title'>Test Status:</span> <span className='info-data'> {candidateList?.test_status}</span></div>  */}
                {/* <div > <span className='info-title'>Test Time:</span> <span className='info-data'> {candidateList?.test_time} Seconds</span></div>  */}
                {/* <div > <span className='info-title'>Test Link:</span> {candidateList?.exam_link && <span className='info-data'> {candidateList?.exam_link}users-test?id={candidateList?.test_id}</span>} </div>  */}
                <div > <span className='info-title'>Test Link:</span> <span className='info-data'> {candidateList?.exam_link}</span> {candidateList?.exam_link && <span> <Button variant="dark" className="copy-button" onClick={handleCopy}>
                  {buttonText}
                </Button></span>}  </div>
              </div>
            </Col>
            <Col>
              <div>
                <div > <span className='info-title'>Create At:</span> <span className='info-data'> {formattedDate}</span></div>
                <div > <span className='info-title'>Questions Generation:</span> <span className='info-data'> {candidateList?.gen_questions_status} <FaCircleCheck className='marg-btm-4 color-green' /></span></div>
                {(candidateList?.exam_status ==='PENDING')&&( <div > <span className='info-title'>Exam Status:</span> <span className='info-data'> {candidateList?.exam_status} <GoXCircleFill className='marg-btm-4 color-red' /> </span></div>)}
                {(candidateList?.exam_status ==='NEW' || candidateList?.exam_status ==='ENDED')&&(<div > <span className='info-title'>Exam Status:</span> <span className='info-data'> {candidateList?.exam_status} <FaCircleCheck className='marg-btm-4 color-green' /> </span></div>)}
                <div > <span className='info-title'>Analysis Status:</span> <span className='info-data'> {candidateList?.gen_analysis_status} <FaCircleCheck className='marg-btm-4 color-green' /> </span></div>
                <div > <span className='info-title'>Overall Score:</span> <span className='info-data'> {candidateList?.overall_avg_score}</span></div>
                <div > <span className='info-title'>Overall Analysis:</span> <span className='info-data'> {candidateList?.overall_analysis}</span></div>
              </div>
            </Col>
          </Row>
        </div>
  

      </div>
    )}
  

    </div>

  );


}
export default CandidateDetailsPage